import HandleIconPath from "@ingka/ssr-icon/paths/handle";

export default HandleIconPath;
